import * as React from 'react';

function SvgFaqHowToPlay(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={50} height={50} {...props}>
      <defs>
        <style>{'.faq_how_to_play_svg__prefix__cls-2{fill:#7689b4}'}</style>
      </defs>
      <g id="faq_how_to_play_svg__prefix__how_to_play" transform="translate(-26 -273)">
        <path
          id="faq_how_to_play_svg__prefix__bounds"
          fill="none"
          d="M0 0h50v50H0z"
          transform="translate(26 273)"
        />
        <g id="faq_how_to_play_svg__prefix__Page-1" transform="translate(32.002 279.122)">
          <g
            id="faq_how_to_play_svg__prefix___010---Idea"
            data-name="010---Idea"
            transform="translate(-.002 -.003)"
          >
            <path
              id="faq_how_to_play_svg__prefix__Shape"
              d="M7 35.722A2.365 2.365 0 014.773 34a3.757 3.757 0 01-.208-1.7c.021-.166.057-.335.095-.505a1.739 1.739 0 00.063-.758c-.051-.2-.2-.3-.568-.509-.148-.084-.3-.17-.438-.269a.909.909 0 01-.374-.621 1.59 1.59 0 01.205-.911c-.215-.165-.45-.35-.587-.474-.583-.477-.2-1.161.035-1.57.085-.15.184-.323.278-.525a1.1 1.1 0 00.072-.637c-.032-.164-.489-.4-.762-.537a4.506 4.506 0 01-.656-.379 1.927 1.927 0 01-.916-1.186 2.622 2.622 0 01.833-1.853 24.357 24.357 0 002.765-4.49 1.048 1.048 0 00.108-.275c0-.174-.205-.373-.514-.657a2.41 2.41 0 01-.92-1.41 2.114 2.114 0 01.167-1.056c.113-.3.242-.586.371-.874a8.239 8.239 0 00.54-1.438l.063-.266a17.124 17.124 0 01.559-2.015 12.1 12.1 0 012.533-4.132 11.465 11.465 0 016.327-3.059 42.139 42.139 0 016.107-.876A14.663 14.663 0 0123.2 1.2a.631.631 0 01-.216 1.244 13.465 13.465 0 00-2.972-.169 41.037 41.037 0 00-5.923.854A10.416 10.416 0 008.434 5.82a10.827 10.827 0 00-2.265 3.7 15.785 15.785 0 00-.515 1.866l-.063.269a9.223 9.223 0 01-.614 1.664c-.119.266-.238.531-.341.8a1.147 1.147 0 00-.1.434c.028.2.268.425.524.659a2.21 2.21 0 01.922 1.578 1.865 1.865 0 01-.249.854 25.4 25.4 0 01-2.889 4.691c-.481.587-.58.821-.583.913a2.681 2.681 0 00.379.308 3.588 3.588 0 00.519.3c.539.275 1.276.653 1.427 1.423a2.367 2.367 0 01-.167 1.421c-.11.234-.223.436-.323.609-.031.055-.063.116-.095.17.261.211.619.479.77.59a.631.631 0 01.12.9 2.367 2.367 0 00-.243.39l.131.075a2.1 2.1 0 011.169 1.29 2.766 2.766 0 01-.055 1.344c-.029.132-.059.263-.076.4a2.51 2.51 0 00.148 1.126 1.117 1.117 0 001.3.84 49.124 49.124 0 005.43-1.641.632.632 0 11.415 1.193 49.692 49.692 0 01-5.585 1.683 2.54 2.54 0 01-.525.053zM3.784 27.3l.02.018-.019-.02z"
              className="faq_how_to_play_svg__prefix__cls-2"
              transform="translate(-.998 -.997)"
            />
            <path
              id="faq_how_to_play_svg__prefix__Shape-2"
              d="M22.594 55.112a.631.631 0 01-.613-.481c-.245-1-1.218-3.74-2.76-4.436a.631.631 0 01.057-1.173 112.04 112.04 0 001.724-.6c.438-.153.767-.268.938-.323 2.624-.83 3.157-1.778 3.142-2.427a.631.631 0 01.619-.646.615.615 0 01.646.616c.037 1.573-1.316 2.805-4.02 3.662-.164.052-.482.164-.905.311l-.568.2a10.058 10.058 0 012.219 4.032l14.32-.04-.042-.063a7 7 0 01-.489-.825 13.232 13.232 0 01-.783-1.976 22.522 22.522 0 01-.787-3.914.631.631 0 111.253-.154 21.3 21.3 0 00.741 3.693 11.926 11.926 0 00.713 1.8 5.9 5.9 0 00.408.683 4.871 4.871 0 01.64 1.2.631.631 0 01-.6.821l-15.847.041z"
              className="faq_how_to_play_svg__prefix__cls-2"
              data-name="Shape"
              transform="translate(-7.579 -17.23)"
            />
            <path
              id="faq_how_to_play_svg__prefix__Shape-3"
              d="M10.825 14.894a.619.619 0 01-.143-.016.631.631 0 01-.472-.758l.063-.273a15.045 15.045 0 01.468-1.71 9.585 9.585 0 012-3.274A7.818 7.818 0 0116.2 6.924a.631.631 0 11.367 1.208 6.61 6.61 0 00-2.91 1.6 8.319 8.319 0 00-1.732 2.841 14.069 14.069 0 00-.421 1.552l-.063.281a.631.631 0 01-.616.488z"
              className="faq_how_to_play_svg__prefix__cls-2"
              data-name="Shape"
              transform="translate(-4.388 -3.17)"
            />
            <circle
              id="faq_how_to_play_svg__prefix__Oval"
              cx={0.631}
              cy={0.631}
              r={0.631}
              className="faq_how_to_play_svg__prefix__cls-2"
              transform="translate(5.052 12.629)"
            />
            <path
              id="faq_how_to_play_svg__prefix__Shape-4"
              d="M40.682 41.051h-3.788A1.894 1.894 0 0135 39.157v-1.263A1.894 1.894 0 0136.894 36h3.788a1.894 1.894 0 011.894 1.894v1.263a1.894 1.894 0 01-1.894 1.894zm-3.788-3.788a.631.631 0 00-.631.631v1.263a.631.631 0 00.631.631h3.788a.631.631 0 00.631-.631v-1.263a.631.631 0 00-.631-.631z"
              className="faq_how_to_play_svg__prefix__cls-2"
              data-name="Shape"
              transform="translate(-13.533 -13.901)"
            />
            <path
              id="faq_how_to_play_svg__prefix__Shape-5"
              d="M39.525 45.788A2.525 2.525 0 0137 43.263v-.631a.631.631 0 01.631-.632h3.788a.631.631 0 01.631.631v.631a2.525 2.525 0 01-2.525 2.526zm-1.263-2.525a1.263 1.263 0 102.525 0z"
              className="faq_how_to_play_svg__prefix__cls-2"
              data-name="Shape"
              transform="translate(-14.271 -16.113)"
            />
            <path
              id="faq_how_to_play_svg__prefix__Shape-6"
              d="M39.682 31a.631.631 0 01-.631-.631v-7.581h-1.263v7.576a.631.631 0 11-1.263 0v-7.576h-.631a1.894 1.894 0 111.894-1.894v.631h1.263v-.631a1.894 1.894 0 111.894 1.894h-.631v7.576a.631.631 0 01-.632.636zm.631-9.47h.631a.631.631 0 10-.631-.631zm-4.419-1.263a.631.631 0 000 1.263h.631v-.631a.631.631 0 00-.631-.636z"
              className="faq_how_to_play_svg__prefix__cls-2"
              data-name="Shape"
              transform="translate(-13.165 -7.634)"
            />
            <path
              id="faq_how_to_play_svg__prefix__Shape-7"
              d="M38.1 26.94h-3.788a.631.631 0 01-.631-.631c0-1.222-1.018-2.008-2.095-2.841a10.846 10.846 0 01-1.452-1.263A8.653 8.653 0 0128 16.34a8.208 8.208 0 1116.415 0 8.657 8.657 0 01-2.131 5.865 10.893 10.893 0 01-1.452 1.263c-1.08.833-2.1 1.619-2.1 2.841a.631.631 0 01-.632.631zm-3.214-1.263h2.639c.271-1.463 1.463-2.385 2.53-3.209a9.866 9.866 0 001.286-1.109 7.382 7.382 0 001.809-5 7.2 7.2 0 00-6.945-7.1 7.2 7.2 0 00-6.945 7.1 7.379 7.379 0 001.808 5 9.885 9.885 0 001.287 1.11c1.072.825 2.26 1.745 2.531 3.208z"
              className="faq_how_to_play_svg__prefix__cls-2"
              data-name="Shape"
              transform="translate(-10.952 -3.579)"
            />
            <path
              id="faq_how_to_play_svg__prefix__Shape-8"
              d="M58.525 21.263h-1.894a.631.631 0 010-1.263h1.894a.631.631 0 110 1.263z"
              className="faq_how_to_play_svg__prefix__cls-2"
              data-name="Shape"
              transform="translate(-21.275 -8.003)"
            />
            <path
              id="faq_how_to_play_svg__prefix__Shape-9"
              d="M51.944 9.163a.631.631 0 01-.444-1.078l1.34-1.339a.631.631 0 11.893.893l-1.339 1.34a.631.631 0 01-.45.184z"
              className="faq_how_to_play_svg__prefix__cls-2"
              data-name="Shape"
              transform="translate(-19.547 -3.045)"
            />
            <path
              id="faq_how_to_play_svg__prefix__Shape-10"
              d="M40.631 4.157A.631.631 0 0140 3.525V1.631a.631.631 0 111.263 0v1.894a.631.631 0 01-.632.632z"
              className="faq_how_to_play_svg__prefix__cls-2"
              data-name="Shape"
              transform="translate(-15.377 -.998)"
            />
            <path
              id="faq_how_to_play_svg__prefix__Shape-11"
              d="M28.531 9.163a.631.631 0 01-.447-.185l-1.339-1.34a.631.631 0 11.893-.893l1.34 1.339a.631.631 0 01-.446 1.078z"
              className="faq_how_to_play_svg__prefix__cls-2"
              data-name="Shape"
              transform="translate(-10.419 -3.045)"
            />
            <path
              id="faq_how_to_play_svg__prefix__Shape-12"
              d="M23.525 21.263h-1.894a.631.631 0 110-1.263h1.894a.631.631 0 110 1.263z"
              className="faq_how_to_play_svg__prefix__cls-2"
              data-name="Shape"
              transform="translate(-8.372 -8.003)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgFaqHowToPlay;
